import axios from '../utils/axios';

export default function fetchCompanyList(adminId) {
    return (
        axios.get('/admin/' + adminId + '/admin-company-list', {})
    )
}
